import React, { useRef } from "react";
import styles from "./BestSellers.module.css";

const BEST_SELLERS = [
  { code: "AK20", name: "Pencil Case with Charms",       price: 36, origPrice: 52, image: "AK20(1).jpg",    link: "https://www.amazon.ae/dp/B0GXF69VVZ" },
  { code: "AK21", name: "Kuromi & Kitty Keychain Pouch", price: 18, origPrice: 28, image: "AK21(1).jpg",    link: "https://www.noon.com/uae-en/kuromi-coin-bag-keychain-lovely-keychain-wallet-cartoon-animal-silicone-coin-purse-with-zipper-kuromi-accessories-for-girls-handbag-car-pendants/Z4E75E78C45FDDF648D50Z/p/" },
  { code: "AK27", name: "Hot & Cold Water Bottle 600ml", price: 49, origPrice: 69, image: "AK27 (5).jpg",   link: "https://www.noon.com/uae-en/stainless-steel-insulated-water-bottle-with-leakproof-lock/Z8ABAF76843DC677CF0DBZ/p/" },
  { code: "AK25", name: "Kuromi Calculator",             price: 24, origPrice: 35, image: "AK25(1).jpg",    link: "https://www.noon.com/uae-en/cute-kids-mini-calculator-lcd-display-battery-powered-included-perfect-for-school-cartoon-design-handheld-black/Z7D6BC933ACF2A31A953BZ/p/" },
  { code: "AK28", name: "Stitch Highlighter",            price: 9,  origPrice: 15, image: "AK28(1).jpeg",   link: "https://www.noon.com/uae-en/stitch-mini-highlighter-pens-cute-pastel-color-markers-perfect-for-school/Z6EF15D6B8907FB3B8D31Z/p/" },
  { code: "AK24", name: "Character Sticky Notes",        price: 9,  origPrice: 14, image: "AK24(1).jpg",    link: "https://www.noon.com/uae-en/cute-cartoon-sticky-notes-set-assorted-shapes-and-designs-memo-notes-for-school-office-and-home/Z7FBE8390AEF3AC3AB222Z/p/" },
];

export default function BestSellers() {
  const trackRef = useRef(null);

  const scroll = (dir) => {
    if (trackRef.current) {
      trackRef.current.scrollBy({ left: dir * 280, behavior: "smooth" });
    }
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <p className={styles.label}>✦ TOP PICKS</p>
          <h2 className={styles.title}>Best Sellers</h2>
          <p className={styles.subtitle}>Trending Picks Everyone Loves</p>
        </div>

        <div className={styles.sliderWrap}>
          <button className={`${styles.arrow} ${styles.arrowLeft}`} onClick={() => scroll(-1)} aria-label="Previous">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>

          <div className={styles.track} ref={trackRef}>
            {BEST_SELLERS.map((p) => (
              <div key={p.code} className={styles.card}>
                <div className={styles.imgWrap}>
                  <img
                    src={`/products/${encodeURIComponent(p.image)}`}
                    alt={p.name}
                    className={styles.img}
                  />
                  <span className={styles.saleBadge}>SALE</span>
                </div>
                <div className={styles.info}>
                  <p className={styles.name}>{p.name}</p>
                  <div className={styles.priceRow}>
                    <span className={styles.origPrice}>AED {p.origPrice}</span>
                    <span className={styles.salePrice}>AED {p.price}</span>
                  </div>
                  <a href={p.link} target="_blank" rel="noopener noreferrer" className={styles.btn}>
                    Order Now
                  </a>
                </div>
              </div>
            ))}
          </div>

          <button className={`${styles.arrow} ${styles.arrowRight}`} onClick={() => scroll(1)} aria-label="Next">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}
